module.exports = __webpack_public_path__ + "static/guggul_gum-563d195b7f5da5f9a1543aed66a00bb6.png";